// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SettingsProvider from './contexts/SettingsProvider';
import './firebase';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts/fonts.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </React.StrictMode>
);
